import React, { Component } from 'react'

export default class MinPriceIndicator extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount () {
    this.updatePrice(this.props)
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    this.updatePrice(nextProps)
  }

  updatePrice (props) {
    const row = props.playersWithMinPrices.find(function (o) {
      return o.count === props.playersCount
    })
    this.setState({
      price: row ? row.price : null
    })
  }

  render () {
    if (this.state.price) {
      return (
        <div className="min_price_indicator">
          starting at ${this.state.price} <span className="per_person"></span>
        </div>
      )
    } else {
      return null
    }
  }
}
